module.exports = __webpack_public_path__ + "media/welcome-message/all_hands@2x-c1fbf073.png";